import React, { Component } from 'react'
import { Modal } from "antd"
import TableInfoView from '../tableInfoView/tableInfoView'
import { checkTableInfoValues, postTableInfo } from '../../postData'

class TableInfoModal extends Component {
  state = {
    isLoading: false,
    tableInfoData: null
  }

  onDataChange = (data) => {
    this.setState({
      tableInfoData: data
    })
  }

  confirmEvent = () => {
    if (!checkTableInfoValues(this.state.tableInfoData)) {
      return
    }
    this.setState({ isLoading: true })
    postTableInfo(this.state.tableInfoData, (flag) => {
      this.setState({ isLoading: false })
      if (flag) {
        this.props.close()
      }
    })
  }

  render() {
    const { isLoading } = this.state
    return <Modal
      title="添加桌台"
      visible
      width="1000px"
      onOk={this.confirmEvent}
      onCancel={this.props.close}
      confirmLoading={isLoading}
    >
      <TableInfoView onDataChange={this.onDataChange} />
    </Modal>
  }
}

export default TableInfoModal


// WEBPACK FOOTER //
// ./src/containers/ClubTable/component/tableInfoModal/tableInfoModal.js